import { PayloadAction } from '@reduxjs/toolkit';

import { FavoriteCatalogData, IState } from '../types/state';

const setFavoriteCatalogs = (
  state: IState,
  action: PayloadAction<FavoriteCatalogData>,
) => {
  state.catalogs.data = action.payload;
};

export default setFavoriteCatalogs;
